import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import GomokuApp from './components/GomokuApp';

ReactDOM.render(
   <GomokuApp />,
  document.getElementById('root')
);

